import { FAVOURITE_LIST } from "../actions/types";

const initialState = {
  favorite: {
    docs: [],
  },
  loading: true,
};

const favriteReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FAVOURITE_LIST:
      return {
        ...state,
        favorite: payload,
        loading: false,
      };

    default:
      return state;
  }
};

export default favriteReducer;
